export default __webpack_public_path__ + "static/media/infoIcon.1f29a10f.svg";